<!--
TODO
like apps: -farfuture-
Terminal
Webbrowser
code editor as contact page or as imprint



TitleBar js apis
pebble logo -> rebble logo


better /desktop integration:
https://router.vuejs.org/en/essentials/passing-props.html

-->
<template>
<!-- In case that /desktop is opened on mobile -->
<v-app class="altbgimg" v-bind:class="{'bgimg':!$vuetify.breakpoint.smAndDown||!windowda}">

  <TitleBar app @bricha="changeBrightness" @tdr="toggleDrawer" :fullscreen="fullscreen"></TitleBar>


  <v-layout>


    <SideNav app :showdrawer="showdrawer"></SideNav>
    <transition name="unshowwindow" appear>
      <v-content id="content" fill-height v-if="windowda">
        <AppWindow @tfs="changeFullscreen" :infs="fullscreen" :head="$route.name">
          <router-view />
        </AppWindow>
      </v-content>
    </transition>
  </v-layout>

<Brightness :brightness="brightness"></Brightness>

</v-app>
</template>

<script>
import AppWindow from './components/AppWindow.vue'
import TitleBar from './partials/TitleBar.vue'
import SideNav from './partials/SideNav.vue'
import Brightness from './partials/Brightness.vue'

export default {
  name: 'app',
  data() {
    return {
      fullscreen: false,
      showdrawer: true,
      windowda: true,
      brightness: 0
    }
  },
  components: {
    AppWindow,
    TitleBar,
    SideNav,
    Brightness
  },
  methods: {
    changeBrightness(b){
      this.brightness = b;
    },
    changeFullscreen() {
      this.showdrawer = this.fullscreen;
      this.fullscreen = !this.fullscreen;
    },
    toggleDrawer() {
      this.showdrawer = !this.showdrawer;
    },
    sizeChanged() {
      console.log(this.$vuetify.breakpoint.name)
      return; // EVERYTHING ELSE IS NOT AS EXPECTED. RESIZE ALSO RUN WITHOUT WINDOW RESIZING
      // if (window.innerWidth < 768) { // Mobile, but not iPhone X
      //   this.isphone = true;
      //   if (window.innerHeight > window.innerWidth) {
      //     // Portrait
      //     this.mobileportrait = true;
      //     this.mobilelandscape = false;
      //     this.showdrawer = false;
      //   } else {
      //     // Landscape
      //     this.mobileportrait = false;
      //     this.mobilelandscape = true;
      //     this.showdrawer = true;
      //   }
      // } else {
      //   this.mobileportrait = false;
      //   this.mobilelandscape = false;
      //   this.isphone = false;
      //   this.showdrawer = !this.fullscreen;
      // }
    },
    routeChnge(to) {
      // SHow desktop
      if (to.path.toLowerCase() == "/desktop") {
        // this.showdrawer = true;
        this.fullscreen = false;
        this.windowda = false;
      } else {
        this.windowda = true;
      }
      // 404 page could be made here

    }
  },
  // beforeMount() {
  //   this.sizeChanged();
  //   let that = this;
  //   this.$nextTick(function() {
  //     window.addEventListener('resize', function(e) {
  //       that.sizeChanged();
  //     });
  //   })
  // },
  created() {
    // console.log(this.$route);
    this.routeChnge(this.$route);

  },
  watch: {
    $route(to, from) {
      this.routeChnge(to)
    }
  }
}
</script>

<style lang="scss">
.unshowwindow-enter-active {
    transition: all 0.1s;
}
.unshowwindow-leave-active {
    transition: all 0.5s;
}
/* .fade-leave-active below version 2.1.8 */
.unshowwindow-enter,
.unshowwindow-leave-to {
    opacity: 0;
}
.unshowwindow-leave-to {
    transform: scale(0.9);
}

html {
    overflow: hidden;
    /* default from vue: scroll */
}

.application,
.bgimg,
body {
    font-family: 'Ubuntu', sans-serif;
}

#content {
    overflow-y: auto;
    position: relative;
    overflow-wrap: break-word;
    padding: 0px !important;
}

.altbgimg {
    background-color: #333 !important;
    overflow: hidden;
    height: 100vh;
    width: 100vw;
}

.bgimg {
    // background-image: url("assets/ubuntu_wallpaper.jpg") !important;
    background-image: url("assets/wallpaper-min.jpg") !important;

    background-size: cover !important;
    background-repeat: no-repeat !important;
    /* otherwise overwritten by initial */
    background-attachment: fixed !important;
}

/* for content pages */

a[target=_blank]::after {
    font-family: 'Material Icons';
    content: '\E89E';
}

a[target=_blank].imginside::after {
    content: '';
}

.textcontent {
    margin: 10px;
}

.textcontentextreme {
    margin: 10px;
    margin-left: 30px;
    margin-right: 30px;
}

.myemail::before {
    content: 'dev';
}
.myemail::after {
    content: 'wuerfeldev.de';
}

hr {
    margin: 12px auto;
    width: 90%;
    border: none;
    height: 1px;
    background: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue